import { ReactNode } from "react";
import { PageTitle } from "./PageTitle";
import { SimpleButton } from "./Button";
import React from "react";

interface PageBarProps {
    title:     ReactNode;
    children?: ReactNode;
    titleSize?: number;
    titleWeight?: "bold" | "semibold" | "normal";
}

export function PageBar({ title, children, titleSize, titleWeight }: PageBarProps) {
    return <div className="d-flex align-items-center gap-2">
        <PageTitle size={titleSize} weight={titleWeight}>
            {title}
        </PageTitle>
        {children}
    </div>;
}

interface ToolButtonProps {
    className?: string;
    onClick:    () => void;
    children:   React.ReactNode;
    loading?:   boolean;
}

export function ToolButton( { className = "", onClick, children, loading = false }: ToolButtonProps ) {    
    return <SimpleButton variant="sm"                     
                  className={`d-flex-align-center px-2 ${className}`}
                  style={{ paddingTop: "2px", paddingBottom: "2px" }}
                  loading={loading}
                  loadingText="Sending…"
                  onClick={onClick}>
        {children}
    </SimpleButton>;
}